import { createSlice } from "@reduxjs/toolkit";
import { type VenueJavascriptDTO } from "@tootsweet/model/datatransfer/VenueDTO";

export interface VenuesStateI {
  venues: Record<string, VenueJavascriptDTO>;
}

const defaultState: VenuesStateI = {
  venues: {}
};

const venuesSlice = createSlice({
  name: "venues",
  initialState: defaultState,
  reducers: {
    setVenues: (state, action) => {
      state.venues[action.payload.trackingID] = action.payload.venue;
    }
  }
});
export default venuesSlice.reducer;
